<template>
  <section
    data-component-id="ErrorPage"
    class="d-flex flex-column justify-center align-center"
    style="height: 100%;"
  >
    <h1
      class="
        text-h1
        grey--text text--darken-2
      "
    >
      {{ code }}
    </h1>
    <p>{{ message }}</p>

    <v-btn
      v-if="canGoBack"
      color="primary"
      class="mt-4"
      text
      @click="$router.back()"
    >
      <v-icon class="ml-0 mr-2" right>mdi-chevron-left mdi-chevron-left</v-icon>
      Retour
    </v-btn>
  </section>
</template>

<script>
export default {
  name: 'ErrorPage',
  props: {
    code: {
      type: Number,
      default: 400
    }
  },
  computed: {
    canGoBack () {
      return window.history.length > 1;
    },
    message () {
      const message = {
        400: 'La page demandée n\'existe pas.',
        401: 'Vous n\'avez pas les droits nécessaires pour accéder à cette page.',
        403: 'Vous n\'avez pas les droits nécessaires pour accéder à cette page.'
      };

      return this.code in message ? message[this.code] : 'Erreur inconnue.';
    }

  },
  methods: {
    handleBack () {
      // Replace current history entry and go back
      this.$router.replace({ path: this.$router.options.history.state.back });
    }
  }
};
</script>
